import {
  CREATE_ASYNC_JOB,
} from '../../types';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  createAsyncJob,
  createAsyncJobPending,
  createAsyncJobFulfilled,
  createAsyncJobRejected,
} = createAsyncActions(CREATE_ASYNC_JOB, 'createAsyncJob');



// WEBPACK FOOTER //
// ./src/features/organization/actions/createActions/createAsyncJobAction.js